import Style from './style'
import MainHeader from 'widget/MainHeader'
import TStyle from 'shared/style/tableStyle'
import timestampCalculator from 'shared/lib/timestampCalculator'
import useGetFranchiseTicketTransactionHistoryList from 'entity/franchise/useGetFranchiseTicketTransactionHistoryList'
import Search from 'widget/Search'
import TableLoading from 'shared/ui/TableLoading'
import SortableHeader from 'shared/ui/SortableHeader'
import Pagenation from 'widget/Pagenation'
import {useState} from 'react'
import {useParams} from 'react-router-dom'
import PaymentCollectionModal from './ui/PaymentCollectionModal'
import {convertClassificationAsName} from 'shared/constant/lookup/ticketType'

const MyFranchiseTicketPossessionDetail = () => {
	const [possessionDetailList, isLoading, refetch] =
		useGetFranchiseTicketTransactionHistoryList()
	const {idx} = useParams()

	const [selectedManagerId, setSelectedManagerId] = useState(null)

	const onClickOpenModal = (e, idx) => {
		e.stopPropagation()
		setSelectedManagerId(idx)
	}

	const btnList = []
	btnList.push({
		label: '매장 이용권 관리',
		clickEvent: (e) => onClickOpenModal(e, idx),
		deactive: false,
	})

	const sizeList = [
		'short',
		'expand',
		'expand',
		'expand',
		'long',
		'medium',
		'long',
	]
	const tableHeadList = [
		{label: 'IDX', sortKey: 'idx'},
		{label: '매장명', sortKey: 'storeName'},
		{label: '매니저 이름', sortKey: 'managerName'},
		{label: '분류', sortKey: 'type'},
		{label: '매장 이용권 유형', sortKey: 'ticketTypeName'},
		{label: '번호', sortKey: 'count'},
		{label: '거래 날짜', sortKey: 'recordAt'},
	]

	const handleModalClose = () => {
		setSelectedManagerId(null)
		refetch()
	}

	return (
		<>
			{selectedManagerId && (
				<PaymentCollectionModal
					managerId={selectedManagerId}
					closeEvent={handleModalClose}
				/>
			)}

			<Style.Wrapper>
				<MainHeader
					title='매장 이용권 소지 세부정보'
					navigateLink='/ticket-manager'
					btnList={btnList}
				/>

				<Search
					classificationFilter={true}
					voucherTypeFilter={true}
					hideSearchInput={true}
				/>

				<Style.AreaDiv>
					<TableLoading isLoading={isLoading}>
						<TStyle.TableDiv>
							<TStyle.TableRow $title>
								{tableHeadList.map((elem, index) => (
									<TStyle.Data key={index} $title $size={sizeList[index]}>
										<SortableHeader sortKey={elem.sortKey}>
											{elem.label}
										</SortableHeader>
									</TStyle.Data>
								))}
							</TStyle.TableRow>
							{possessionDetailList?.data?.items?.map((item, index) => {
								return (
									<TStyle.TableRow key={index} $odd={index % 2 === 1}>
										<TStyle.Data $size={sizeList[0]}>{item.idx}</TStyle.Data>
										<TStyle.Data $size={sizeList[1]}>
											{item.storeName}
										</TStyle.Data>
										<TStyle.Data $size={sizeList[2]}>
											{item.managerName}
										</TStyle.Data>
										<TStyle.Data $size={sizeList[3]}>
											{convertClassificationAsName[item.type]}
										</TStyle.Data>
										<TStyle.Data $size={sizeList[4]}>
											{item.ticketTypeName}
										</TStyle.Data>
										<TStyle.Data $size={sizeList[5]}>{item.count}</TStyle.Data>
										<TStyle.Data $size={sizeList[6]}>
											{timestampCalculator(item.recordAt)}
										</TStyle.Data>
									</TStyle.TableRow>
								)
							})}
						</TStyle.TableDiv>
					</TableLoading>
				</Style.AreaDiv>

				{possessionDetailList?.data?.maxPage > 0 && (
					<Pagenation maxPage={possessionDetailList?.data?.maxPage} />
				)}
			</Style.Wrapper>
		</>
	)
}

export default MyFranchiseTicketPossessionDetail
